import { Banner, Link } from '@farol-ds/react'
import {
  PersistentAlertBannerIcon,
  PersistentAlertBannerLink,
} from '@jusbrasil-web/shared-apollo-client/types'
import { useUserSession } from '@jusbrasil-web/shared-user-session'
import { Fragment, useEffect, useState } from 'react'

import { usePersistentAlertBannerDispatcher } from '../../hooks'
import { jusIAPersistentAlertBannerPersisted } from '../../utils'
import { AlertIcon } from '../alert-icon'
import styles from './jusia-alert.module.scss'

interface JusIAAlertProps {
  text?: string | null
  icon?: PersistentAlertBannerIcon | null
  link?: PersistentAlertBannerLink | null
}

export function JusIAAlert(props: JusIAAlertProps) {
  const { sendTopbarEvent, ref } = usePersistentAlertBannerDispatcher<HTMLDivElement>()
  const user = useUserSession()

  const [isVisible, setIsVisible] = useState(!!props)
  const { icon, text, link } = props ?? {}

  const handleVisibilityChange = (visible: boolean): void => {
    if (!visible) {
      jusIAPersistentAlertBannerPersisted.set(user?.pid?.toString())
      sendTopbarEvent('JusIAToastClosed')
    }
    setIsVisible(visible)
  }

  const handleLinkClick = () => {
    jusIAPersistentAlertBannerPersisted.set(user?.pid?.toString())
    sendTopbarEvent('JusIAToastClicked')
  }

  useEffect(() => {
    if (isVisible) {
      sendTopbarEvent('JusIAToastView')
    }
  }, [isVisible, sendTopbarEvent])

  if (!isVisible) return null

  return (
    <Banner
      ref={ref}
      visible={isVisible}
      defaultVisible={false}
      level="app"
      type="positive"
      onVisibleChange={handleVisibilityChange}
      className={styles.jusiaAlert}
    >
      <Banner.Content>
        <Banner.Title>
          {icon && (
            <Banner.Icon>
              <AlertIcon icon={icon} data-testid="jusia-alert-icon" />
            </Banner.Icon>
          )}
          {text}
          <Fragment>
            {' '}
            <Link href={link?.url} onClick={handleLinkClick}>
              {link?.label}
            </Link>
          </Fragment>
        </Banner.Title>
      </Banner.Content>
      <Banner.IconClose />
    </Banner>
  )
}
